import queryString from 'query-string'
import { useEffect, useCallback, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router'

import { ManageBrandDialogContextProvider } from '@src/components/brands/manageBrandsDialogContext'
import { helpWidget } from '@src/lib/HelpWidget'
import postMessage from '@src/lib/postMessage'

import BeaconHider from '../../../lib/BeaconHider'
import {
  userSelector,
  currentRetailerAccountSelector,
} from '../../../stores/app/selectors'
import ManageBrand from '../../brands/ManageBrand'

//Temporary page meant to be used by R1 in an iframe only.
//ManageBrandPage
export function ManageBrandPage() {
  const params = useParams()

  /** @type {React.RefObject<HTMLDivElement>} */
  const containerRef = useRef(null)

  const currentUser = useSelector(userSelector)
  const currentRetailerAccount = useSelector(currentRetailerAccountSelector)

  useEffect(() => {
    //Hacky, supress the HelpScout beacon on this page.
    try {
      helpWidget.hideAll()
    } catch (error) {
      console.error(error)
    }

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0]
      if (!entry) {
        return
      }

      postMessage(window.parent, {
        type: 'manageBrand/size',
        payload: {
          height: entry.contentRect.height,
        },
      })
    })
    observer.observe(containerRef.current)

    postMessage(window.parent, {
      type: 'manageBrand/load',
    })

    return () => {
      observer.disconnect()
    }
  }, [])

  const handleOnClose = useCallback(() => {
    postMessage(window.parent, {
      type: 'manageBrand/close',
    })
  }, [])

  const [isValid, setIsValid] = useState(true)

  if (currentUser && currentRetailerAccount) {
    const { initialTab, subtitle, validationMode, shouldHighlightMissing } =
      queryString.parse(window.location.search)
    const { retailerSlug } = params
    const retailer = currentRetailerAccount.retailers.find(
      (r) => r.slug === retailerSlug,
    )

    return (
      <div ref={containerRef}>
        <ManageBrandDialogContextProvider
          value={{
            isValid,
            setIsValid,
            shouldHighlightMissing,
            validationMode,
          }}
        >
          <ManageBrand
            retailerId={retailer.id}
            initialTab={initialTab}
            onClose={handleOnClose}
            subtitle={subtitle}
          />
        </ManageBrandDialogContextProvider>
        <BeaconHider />
      </div>
    )
  } else {
    return null
  }
}
